import React from 'react'
import useApp from '../../store/app/appContext';
import PageWrapper from '../../containers/app/PageWrapper';
import ScansProvider from '../../store/scans/scansProvider';
import PatientScansList from '../../containers/patients/PatientScansList';
import { useParams } from 'react-router';

function PatientScans() {
  const { id } = useParams();

  const { appState: { user }} = useApp();

  if (!user) return '';
  if (!user._id) return '';

  return (
    <ScansProvider>
      <PageWrapper navbar title={'Patient scans'}>
         {id && <PatientScansList patientId={id} />}
      </PageWrapper>
    </ScansProvider>
  )
}

export default PatientScans;
